/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetAccessControlRequest = {
  agentId: string;
};

/** @internal */
export const GetAccessControlRequest$inboundSchema: z.ZodType<
  GetAccessControlRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type GetAccessControlRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const GetAccessControlRequest$outboundSchema: z.ZodType<
  GetAccessControlRequest$Outbound,
  z.ZodTypeDef,
  GetAccessControlRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function getAccessControlRequestToJSON(
  getAccessControlRequest: GetAccessControlRequest,
): string {
  return JSON.stringify(
    GetAccessControlRequest$outboundSchema.parse(getAccessControlRequest),
  );
}
export function getAccessControlRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetAccessControlRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetAccessControlRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetAccessControlRequest' from JSON`,
  );
}
